module.exports = __webpack_public_path__ + "img/check-off.8601faff.svg";